import { StrategicAxesRepository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: StrategicAxesRepository): Interactor {
  return ({ projectStrategicAxis, nextProjectStrategicAxis }) =>
    present(
      repository
        .editProjectStrategicAxis(
          projectStrategicAxis,
          nextProjectStrategicAxis,
        )
        .then((projectStrategicAxis) => ({ projectStrategicAxis }))
        .catch(() =>
          Promise.reject({ projectStrategicAxis, nextProjectStrategicAxis }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
